<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-if="solo"
        v-bind="attrs"
        v-on="on"
        class="blue--text caption text-uppercase font-weight-medium"
        style="cursor: pointer"
        >
        {{ text }}
      </div>

      <v-btn
        v-else
        :color="color"
        dark
        :text='button_text'
        v-bind="attrs"
        v-on="on"
        >
        {{ text }}
      </v-btn>
    </template>
    <slot>
    </slot>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  },

  props: {
    text: {
      type: String,
      required: true,
    },
    button_text: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: "primary"
    },
    solo: {
      type: Boolean,
      required: false,
      default: false
    }
  },
}
</script>
